export function flattenPinnedIndicators(data) {
  if (!data) return [];
  return data.flatMap((item) => ({
    ...item.indicator,
    publication: {
      id: item.id,
      name: item.name,
      publicationTranslations: item.publicationTranslations,
      yearType: item.yearType,
      periodic: item.periodic,
    },
  }));
}

export function safeList(fetcher, { minLength = 0, slice } = {}) {
  if (
    fetcher.error ||
    fetcher.isLoading ||
    fetcher.data === undefined ||
    fetcher.data === null ||
    !fetcher.data.data
  ) {
    return [];
  }
  const list = fetcher.data.data;
  if (minLength > 0 && list.length <= minLength) {
    return [];
  }
  if (typeof slice === "number") {
    return list.slice(0, slice);
  }
  return list;
}
